import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const MeasurementUnitSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectMeasurementUnit") : title;
  const [measurementUnits, setMeasurementUnits] = useState([]);
  const [selected, setSelected] = useState(null);

  const handleChange = (e) => {
    setSelected(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const getMeasurementUnits = async () => {
    try {
      const response = await apiService.get(`api/v1/measurement-units`);
      const availableOptions = response.map((el) => {
        return {
          value: el.id,
          label: el.description,
        };
      });
      setMeasurementUnits(availableOptions);
      if (defaultValue) {
        let selected = availableOptions.find((e) => e.value === defaultValue);
        setSelected(selected);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getMeasurementUnits();
  }, []);

  useEffect(() => {
    const selectedMeasurementUnit = measurementUnits.find((el) => el.value === defaultValue);
    if (selectedMeasurementUnit) setSelected(selectedMeasurementUnit);
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          isClearable={true}
          className="primary"
          name="measurementUnitSelect"
          onChange={handleChange}
          value={selected}
          options={measurementUnits}
          noOptionsMessage={() => t("messages.noMeasurementUnitsAreAvailable")}
          placeholder={`${title}`}
        />
      </Form.Group>
    </>
  );
};

export default MeasurementUnitSelect;
